import { ComponentType, useMemo } from 'react';

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

import { DialogButton } from 'components';
import { DeleteDialog } from 'components/Dialogs';
import strings from 'constants/index';

import DeleteWithReasonDialog from '../DeleteWithReasonDialog';

type DeleteButtonProps = {
  entityName: string;
  onDelete: () => Promise<void>;
  shouldShowLabel?: boolean;
};
type DeleteWithReasonButtonProps = {
  entityName: string;
  onDelete: (reason: string) => Promise<void>;
  shouldShowLabel?: boolean;
  label?: string;
  startIcon?: ComponentType;
  rules?: any;
  additionalMessage?: string;
};

export const DeleteButton = (props: DeleteButtonProps) => (
  <DialogButton
    startIcon={<DeleteForeverIcon />}
    label={
      props.shouldShowLabel === null || props.shouldShowLabel === undefined || props.shouldShowLabel
        ? strings.delete
        : ''
    }
    dialog={DeleteDialog}
    dialogProps={props}
  />
);

export const DeleteWithReasonButton = (props: DeleteWithReasonButtonProps) => {
  const icon = useMemo(
    () => (props.startIcon ? <props.startIcon /> : <DeleteForeverIcon />),
    [props],
  );

  const label = useMemo(
    () =>
      props.shouldShowLabel === null || props.shouldShowLabel === undefined || props.shouldShowLabel
        ? props.label || strings.delete
        : '',
    [props],
  );

  return (
    <DialogButton
      startIcon={icon}
      label={label}
      dialog={DeleteWithReasonDialog}
      dialogProps={props}
    />
  );
};
